import { ErrorHandler, Injectable } from '@angular/core';
import { LogService } from '@core/services/log.service';

@Injectable()
export class GlobalErrorHandler extends ErrorHandler {
  chunkFailedMessage = /Loading chunk [\d]+ failed/;

  constructor(private logService: LogService) {
    super();
  }

  handleError(error: Error) {
    this.logService.fatal('Unhandled application error', error);

    if (this.chunkFailedMessage.test(error.message)) {
      window.location.reload();
    }

    super.handleError(error);
  }
}
